import React from 'react';
import EventEmitter from 'events';

export default {
  get,
  useWindowDimensions,
};
export const Dimensions = {
  get,
};
export function useWindowDimensions() {
  return React.useSyncExternalStore(_subscribe, get);
}

type Dimension = {
  width: number;
  height: number;
};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}

let g_dimensions: Dimension | null = null;
let g_resizeSet = false;
export function get(): Dimension {
  if (!g_resizeSet) {
    g_resizeSet = true;
    window.addEventListener('resize', _onResize);
  }
  if (!g_dimensions) {
    g_dimensions = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }
  return g_dimensions;
}
function _onResize() {
  g_dimensions = null;
  _emit('resize');
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
